import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import withRouter from '../.././components/withRouter';
import TableContainer from '../.././components/TableContainerReactTable';
import { AuditLog } from '../../types/audit-log';
import { getHistoricoDeAlteracoes } from '../../api/auditLogApi';
import { format } from 'date-fns';

const Index = (props: any) => {
    const [data, setData] = useState<AuditLog[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        getHistoricoDeAlteracoes()
            .then((res) => {
                setData(res);
            })
            .catch(() => {
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const columns = useMemo(
        () => [
            {
                header: '#',
                accessorKey: 'id',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Usuário',
                accessorFn: (row: any) => {
                    const context = row.context;
                    if (context.impersonatedUser) {
                        return `${context.impersonatedUser.name} (Personificado como ${context.user.email})`;
                    }

                    if (context.user) {
                        return `${context.user.name}`;
                    }

                    return '-';
                },
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Method',
                cell: (cell: any) => {
                    const row = cell.row.original;
                    const context = row.context;
                    const actionColors: { [key: string]: string } = {
                        GET: 'bg-primary-subtle text-primary',
                        POST: 'bg-secondary-subtle text-secondary',
                        DELETE: 'bg-danger-subtle text-danger',
                        PUT: 'bg-success-subtle text-success',
                        PATCH: 'bg-warning-subtle text-warning',
                    };
                    const colorClass = actionColors[context.method] || 'bg-soft-secondary';
                    return (
                        <span className={`badge ${colorClass}`}>{context.method}</span>
                    );
                },
                enableColumnFilter: false,
            },
            {
                header: 'IP',
                accessorFn: (row: any) => row.ipv4 || row.ipv6 || '-',
                enableColumnFilter: false,
            },
            {
                header: 'Entity',
                accessorKey: 'entity',
                enableColumnFilter: false,
            },
            {
                header: 'Action',
                cell: (cell: any) => {
                    const row = cell.row.original;
                    const action = row.action.toUpperCase();
                    const actionColors: { [key: string]: string } = {
                        INSERT: 'bg-success-subtle text-success',
                        DELETE: 'bg-danger-subtle text-danger',
                        UPDATE: 'bg-secondary-subtle text-secondary',
                    };
                    const colorClass = actionColors[action] || 'bg-info-subtle text-info';
                    return (
                        <span className={`badge ${colorClass}`}>{action}</span>
                    );
                },
                enableColumnFilter: false,
            },
            {
                header: 'From',
                cell: (cell: any) => {
                    const row = cell.row.original;
                    return (
                        <div>
                            {row.from ? Object.entries(row.from).map(([key, value]) => (
                                <div key={key}>
                                    <strong>{key}:</strong> {JSON.stringify(value, null, 2)}
                                </div>
                            )) : '-'}
                        </div>
                    );
                },
                enableColumnFilter: false,
            },
            {
                header: 'To',
                cell: (cell: any) => {
                    const row = cell.row.original;
                    return (
                        <div>
                            {row.to ? Object.entries(row.to).map(([key, value]) => (
                                <div key={key}>
                                    <strong>{key}:</strong> {JSON.stringify(value, null, 2)}
                                </div>
                            )) : '-'}
                        </div>
                    );
                },
                enableColumnFilter: false,
            },
            {
                header: 'Timestamp',
                accessorFn: (row: any) => format(row.timestamp, 'dd/MM/yyyy HH:mm:ss XXX'),
                enableColumnFilter: false,
            },
        ],
        [],
    );

    document.title = 'Logs de auditoria | Ad Pulse';
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <Row className="g-4 align-items-center">
                                        <div className="col-sm">
                                            <div>
                                                <h5 className="card-title mb-0">Logs de auditoria</h5>
                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <React.Fragment>
                                        {!loading ? <TableContainer
                                                divClass="table-responsive"
                                                columns={(columns || [])}
                                                data={(data || [])}
                                                isGlobalFilter={true}
                                                customPageSize={30}
                                                SearchPlaceholder="Procurar..."
                                            /> :
                                            <div className="text-center">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Carregando...</span>
                                                </div>
                                            </div>}
                                    </React.Fragment>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Index);